import React from "react";
import { Outlet } from "react-router-dom";
import { setTitle } from "../helpers/MetaTag";

const BlankLayout = ({ metaTitle }) => {
  setTitle(`HobbyConnect | ${metaTitle}`);

  return <Outlet />;
};

export default BlankLayout;
